export const opportunityActivities = (state) => state.opportunityActivities
export const emailActivityTypeEnum = (state) => state.emailActivityTypeEnum
export const callActivityTypeEnum = (state) => state.callActivityTypeEnum
export const activityTypes = (state) => state.activityTypes
